import { createContext, useContext } from 'react';

// Compatibility fallback for servers that do not yet return subject_options.
export const STUDY_SUBJECTS = [
  ['turkce', 'Türkçe'], ['paragraf', 'Paragraf'], ['matematik', 'Matematik'],
  ['fen_bilimleri', 'Fen Bilimleri'], ['sosyal_bilgiler', 'Sosyal Bilgiler'],
  ['inkilap_tarihi', 'İnkılap Tarihi'],
  ['ingilizce', 'İngilizce'], ['din_kulturu', 'Din Kültürü'],
];
export const StudySubjectsContext = createContext(STUDY_SUBJECTS);
export const StudyEntrySubjectsContext = createContext(STUDY_SUBJECTS);
export const useStudySubjects = (editable = false) => useContext(editable ? StudyEntrySubjectsContext : StudySubjectsContext);

export function studySubjects(options, fallback = STUDY_SUBJECTS, editable = false) {
  if (!Array.isArray(options) || !options.length) return editable ? fallback.filter(([key]) => key !== 'inkilap_tarihi') : fallback;
  const byKey = new Map(options.map((item) => [item.key, item]));
  return fallback.filter(([key]) => !editable || (key === 'inkilap_tarihi'
    ? byKey.get(key)?.available === true : byKey.get(key)?.available !== false))
    .map(([key, label]) => [key, byKey.get(key)?.name || label]);
}
